import React from "react";

export default function PDFToText({ file }) {
  const [text, setText] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const cancelRef = React.useRef(false);
  React.useEffect(() => {
    // Set workerSrc for pdfjs
    const workerSrc = require("pdfjs-dist/build/pdf.worker.entry");
    require("pdfjs-dist").GlobalWorkerOptions.workerSrc = workerSrc;
    if (!file) {
      setText("");
      setLoading(false);
    }
    // Don't auto-convert on file change
    // eslint-disable-next-line
  }, [file]);

  const handleConvert = async () => {
    if (!file) return;
    setLoading(true);
    setText("");
    cancelRef.current = false;
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await require("pdfjs-dist").getDocument({ data: arrayBuffer }).promise;
    let allText = "";
    for (let i = 1; i <= pdf.numPages; i++) {
      if (cancelRef.current) {
        setLoading(false);
        return;
      }
      const page = await pdf.getPage(i);
      const content = await page.getTextContent();
      allText += content.items.map(item => item.str).join(" ") + "\n";
    }
    setText(allText);
    setLoading(false);
  };

  const handleCancel = () => {
    cancelRef.current = true;
    setLoading(false);
  };

  return (
    <div>
      {!file && (
        <div style={{ color: '#c00', fontSize: 17, margin: '24px 0', textAlign: 'center', fontWeight: 500 }}>
          No file selected. Please upload a PDF file to begin.
        </div>
      )}
      {file && !loading && text === "" && (
        <button onClick={handleConvert} style={{ padding: '10px 24px', fontSize: 16, borderRadius: 8, background: '#007bff', color: '#fff', border: 'none', marginBottom: 16 }}>Convert</button>
      )}
      {loading && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span>Extracting text...</span>
          <button onClick={handleCancel} style={{ color: 'red' }}>Cancel</button>
        </div>
      )}
      {text && (
        <div>
          <textarea value={text} readOnly rows={12} style={{ width: "100%" }} />
        </div>
      )}
    </div>
  );
}

